import React, { Component } from 'react';
import { connect } from 'react-redux';
import HotKeys from 'react-shortcut';

import * as ClipboardState from '../../../state/reducer/clipboard/clipboard';
import KeyBindings from './KeyBindings';
import Console from '../../../lib/debug';

class CalendarHotKeys extends Component {
    copyTrigger = () => {
        if (!this.props.isPaused) ClipboardState.copy();
    };

    deleteTrigger = () => {
        if (!this.props.isPaused) ClipboardState.showDeleteDialog();
    };

    pasteTrigger = () => {
        if (!this.props.isPaused) ClipboardState.paste();
    };

    escapeTrigger = () => {
        if (!this.props.isPaused) ClipboardState.clearSelected();
    };

    render() {
        Console.render('CalendarHotKeys');
        return (
            <div>
                <HotKeys
                    keys={KeyBindings.copy}
                    simultaneous
                    onKeysCoincide={this.copyTrigger}
                />
                <HotKeys
                    keys={KeyBindings.copyWin}
                    simultaneous
                    onKeysCoincide={this.copyTrigger}
                />
                <HotKeys
                    keys={KeyBindings.backspace}
                    onKeysCoincide={this.deleteTrigger}
                />
                <HotKeys
                    keys={KeyBindings.delete}
                    onKeysCoincide={this.deleteTrigger}
                />
                <HotKeys
                    keys={KeyBindings.paste}
                    simultaneous
                    onKeysCoincide={this.pasteTrigger}
                />
                <HotKeys
                    keys={KeyBindings.pasteWin}
                    simultaneous
                    onKeysCoincide={this.pasteTrigger}
                />
                <HotKeys
                    keys={KeyBindings.escape}
                    simultaneous
                    onKeysCoincide={this.escapeTrigger}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        isPaused: state.clipboard.hotkeysArePaused
    };
};

export default connect(mapStateToProps)(CalendarHotKeys);
